import { useContext, useContextSelector } from 'use-context-selector';
import { FundTransferContext } from './FundTransferContext';

const useFundTransferState = () => {
  const context = useContext(FundTransferContext);

  if (context === undefined) {
    throw new Error('useFundTransferState must be used within FundTransferProvider');
  }

  return context;
};

const useCurrencies = () => {
  const context = useContextSelector(FundTransferContext, state => state.currencies);

  if (context === undefined) {
    throw new Error('useCurrencies must be used within FundTransferProvider');
  }

  return context;
};

const useCountries = () => {
  const context = useContextSelector(FundTransferContext, state => state.countries);

  if (context === undefined) {
    throw new Error('useCountries must be used within FundTransferProvider');
  }

  return context;
};

const useChargingMethods = () => {
  const context = useContextSelector(FundTransferContext, state => state.chargingMethods);

  if (context === undefined) {
    throw new Error('useChargingMethods must be used within FundTransferProvider');
  }

  return context;
};

const useFundTransferLoadingState = (
  loadingProperty: 'isLoadingCurrencies' | 'isLoadingCountries' | 'isLoadingChargingMethods',
) => {
  const context = useContextSelector(FundTransferContext, state => state[loadingProperty]);

  return context;
};

const useFundTransferErrorState = (errorProperty: 'currenciesError' | 'countriesError' | 'chargingMethodsError') => {
  const context = useContextSelector(FundTransferContext, state => state[errorProperty]);

  return context;
};

export {
  useFundTransferState,
  useCurrencies,
  useChargingMethods,
  useCountries,
  useFundTransferLoadingState,
  useFundTransferErrorState,
};
